import { getMockNotificationHistory, USE_NOTIFICATION_DEMO_DATA } from "./mockData";

const NOTIFICATION_HISTORY_KEY = "notification_history_records_v1";

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch (_error) {
    return [];
  }
};

export const getNotificationHistory = () => {
  const raw = localStorage.getItem(NOTIFICATION_HISTORY_KEY);
  if (raw === null && USE_NOTIFICATION_DEMO_DATA) {
    const seededRecords = getMockNotificationHistory();
    localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify(seededRecords));
    return seededRecords.sort((a, b) => new Date(b.sentAt || 0).getTime() - new Date(a.sentAt || 0).getTime());
  }

  const parsedRecords = safeParse(raw);
  const records = Array.isArray(parsedRecords) ? parsedRecords : [];
  if (records.length === 0 && USE_NOTIFICATION_DEMO_DATA) {
    const seededRecords = getMockNotificationHistory();
    localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify(seededRecords));
    return seededRecords.sort((a, b) => new Date(b.sentAt || 0).getTime() - new Date(a.sentAt || 0).getTime());
  }

  return records.sort((a, b) => new Date(b.sentAt || 0).getTime() - new Date(a.sentAt || 0).getTime());
};

export const getNotificationHistoryById = (id) => {
  if (!id) {
    return null;
  }
  return getNotificationHistory().find((record) => String(record.id) === String(id)) || null;
};

export const addNotificationHistory = (record) => {
  const existing = getNotificationHistory();
  const nextRecord = {
    id: record?.id || `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    sentAt: record?.sentAt || new Date().toISOString(),
    ...record,
  };
  localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify([nextRecord, ...existing]));
  return nextRecord;
};

export const updateNotificationHistory = (recordId, updates) => {
  if (!recordId) {
    return null;
  }

  const existing = getNotificationHistory();
  const nextRecords = existing.map((record) =>
    String(record.id) === String(recordId)
      ? {
          ...record,
          ...updates,
          id: record.id,
          sentAt: updates?.sentAt || record.sentAt || new Date().toISOString(),
        }
      : record
  );

  localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify(nextRecords));
  return nextRecords.find((record) => String(record.id) === String(recordId)) || null;
};

export const clearNotificationHistory = () => {
  if (USE_NOTIFICATION_DEMO_DATA) {
    localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify(getMockNotificationHistory()));
    return;
  }

  localStorage.setItem(NOTIFICATION_HISTORY_KEY, JSON.stringify([]));
};
